import dayjs from "dayjs";
import mime from "mime";

export const TICKET_STATUS_MD5 = {
  pending: import.meta.env.VITE_APP_ID_STATUS_TICKET_PENDING_MD5,
  closed: import.meta.env.VITE_APP_ID_STATUS_TICKET_CLOSED_MD5,
  needInfo: import.meta.env.VITE_APP_ID_STATUS_TICKET_NEED_INFO_MD5,
  inProgress: import.meta.env.VITE_APP_ID_STATUS_TICKET_IN_PROGRESS_MD5,
};

export const TICKET_STATUS = {
  pending: import.meta.env.VITE_APP_ID_STATUS_TICKET_PENDING,
  closed: import.meta.env.VITE_APP_ID_STATUS_TICKET_CLOSED,
  needInfo: import.meta.env.VITE_APP_ID_STATUS_TICKET_NEED_INFO,
  inProgress: import.meta.env.VITE_APP_ID_STATUS_TICKET_IN_PROGRESS,
};
export const getNationalitiesAndGovernorates = (
  survey,
  nationalityList,
  FormesJuridiquesList,
  secteurData,
  gouvernoratList
) => {
  survey.getAllQuestions().forEach((question) => {
    if (question.name.toLowerCase().includes("_nationality")) {
      question.choices = nationalityList;
    }

    if (question.name === "legal_entity_legal_form") {
      question.choices = FormesJuridiquesList;
    }

    if (question.name === "training_nature_data") {
      question.panels.forEach((panel) => {
        panel.questions.forEach((question) => {
          if (question.name === "training_type_data_sector") {
            question.choices = secteurData;
          }
        });
      });
    }

    if (question.name === "trainer_data") {
      question.panels.forEach((panel) => {
        panel.questions.forEach((question) => {
          if (question.name.toLowerCase().includes("_nationality")) {
            question.choices = nationalityList;
          }
          if (question.name.toLowerCase().includes("_governorate")) {
            question.choices = gouvernoratList;
          }
        });
      });
    }

    if (question.name === "management_data") {
      question.panels.forEach((panel) => {
        panel.questions.forEach((question) => {
          if (question.name.toLowerCase().includes("_governorate")) {
            question.choices = gouvernoratList;
          }

          if (question.name.toLowerCase().includes("_nationality")) {
            question.choices = nationalityList;
          }
        });
      });
    }
    if (question.name.toLowerCase().includes("_governorate")) {
      question.choices = gouvernoratList;
    }
  });
};

export const parseDate = (dateStr) => {
  if (dayjs(dateStr, "YYYY-MM-DD", true).isValid()) {
    return dayjs(dateStr).format("YYYY-MM-DD");
  }
  if (dayjs(dateStr, "YYYY/MM/DD", true).isValid()) {
    return dayjs(dateStr, "YYYY/MM/DD").format("YYYY-MM-DD");
  }
  if (dayjs(dateStr, "DD/MM/YYYY", true).isValid()) {
    return dayjs(dateStr, "DD/MM/YYYY").format("YYYY-MM-DD");
  }
};

export const setUserData = (userData, role,survey,id_affaire) => {
  const fieldsToSet = [
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_passeport"
          : "investor_passport",
      userDataField: "passport",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_ministerial_auth_date"
          : "",
      userDataField: "date_autorisation_ministre",
    },

    {
      surveyField:
        role === "directeur"
          ? "establishment_director_date_expiration_passeport"
          : "investor_date_expiration_passeport",
      userDataField: "expiration_passeport",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_experience_years"
          : "",
      userDataField: "experience_years",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_first_name"
          : "investor_first_name_ar",
      userDataField: "prenom_ar",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_last_name"
          : "investor_last_name_ar",
      userDataField: "nom_ar",
      readOnly: true,
    },

    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_first_name_fr"
          : "investor_first_name_fr",
      userDataField: "prenom",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_last_name_fr"
          : "investor_last_name_fr",
      userDataField: "nom",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_email"
          : "investor_email",
      userDataField: "mail",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_birth_date"
          : "investor_birth_date",
      userDataField: "date_naiss_user",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_genre"
          : "investor_civility",
      userDataField: "civilite",
      readOnly: true,
    },

    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_nationality"
          : "investor_nationality",
      userDataField: "nationality",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_cin_number"
          : "investor_cin",
      userDataField: "cin",
      readOnly: true,
    },

    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_date_delivrance"
          : "investor_date_delivrance",
      userDataField: "delivrance_date",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_birth_place"
          : "investor_birth_place",
      userDataField: "birthplace",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_education_level"
          : "investor_eduction_level",
      userDataField: "niveau_scolaire",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_phone_number"
          : "investor_phone_number",
      userDataField: "telephone",
      readOnly: true,
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_address"
          : "investor_residence_address",
      userDataField: "adresse",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_governorate"
          : "investor_residence_governorate",
      userDataField: "goverment",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_delegation"
          : "investor_residence_delegation",
      userDataField: "delegation",
    },
    {
      surveyField:
        role === "directeur" ? "" : "investor_residence_postal_code",
      userDataField: "code_postal",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_specific_needs"
          : "investor_specific_needs",
      userDataField: "besoins_specifiques",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_cin_copie"
          : "investor_copie_cin",
      userDataField: "copie_cin",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_passeport_copie"
          : "investor_copie_passeport",
      userDataField: "copie_passeport",
    },
    {
      surveyField:
        role === "directeur"
          ? "establishment_director_data_director_folder"
          : "investor_copie_cv",
      userDataField: "copie_cv",
    },
    {
      surveyField:
        role === "directeur" ? "copie_autorisation_ministre" : "",
      userDataField: "copie_autorisation_ministre",
    },
  ];


  fieldsToSet.forEach((field) => {
    const { surveyField, userDataField, readOnly } = field;
    const value =
      surveyField.includes("copie") && userData[userDataField]
        ? setFileValues(userData[userDataField])
        : surveyField.includes("_date") && userData[userDataField]
        ? parseDate(userData[userDataField])
        : userData[userDataField];
    const question = survey.getQuestionByName(surveyField);

    if (!value && !id_affaire) {
      if (question) {
        question.readOnly = false;
    }
    
    } else {
      value && survey.setValue(surveyField, value);
      if (readOnly && question) {
        question.readOnly = true;
      }
    }
  });
};


const setFileValues = (value) => {
  const fileType = mime.getType(value.name);
  const file = {
    content: value.content,
    name: value.name,
    type: fileType,
  };
  return file;
};


export const getReadOnlyQuestions = (survey,id_affaire,nationalityList ) => {
  if (id_affaire) {
    sessionStorage.setItem("consulter", true);
    survey.getAllQuestions().map((question) => {
      question.readOnly = true;
      if (
        question.name.toLowerCase().includes("reservation_number") ||
        question.name.toLowerCase().includes("tax_number")
      ) {
        question.readOnly = true;
      }
      if (question.name.toLocaleLowerCase().includes("_nationality")) {
        question.choices = nationalityList;
      }
    });

    const trainer_data = survey.getQuestionByName("trainer_data");
    trainer_data?.panels.map((panel) => {
      panel.questions.map((question) => {
        if (
          question.name === "trainer_data_cin_number" ||
          question.name === "trainer_data_passport"
        ) {
          question.readOnly = true;
        }
        if (question.name === "trainer_data_nationality") {
          question.choices = nationalityList;
        }
      });
    });

    const management_data = survey.getQuestionByName("management_data");
    management_data?.panels.map((panel) => {
      panel.questions.map((question) => {
        // if (question.name === "management_data_staff_birth_date") {
        question.readOnly = true;
        if (question.name === "management_data_staff_nationality") {
          question.choices = nationalityList;
        }
        // }
      });
    });

    survey.showCompleteButton = false;
    survey.editText = "Consulter - الإطلاع";
  } else {
    sessionStorage.setItem("consulter", false);
  }
}